<template>
  <el-dialog
    :visible="is_visible"
    ref="dialog"
    :title="metadataTitle"
    :width="popupWidth"
    :close-on-click-modal="false"
    @close="closeDialog"
    class="dialog"
  >
    <div
      class="dialog__content"
      v-loading="
        clickSaveform || dialogLoading || !Object.keys(metaData).length
      "
    >
      <div
        v-if="metaData?.panels?.length && metaData.panels[0].rows[0]"
        :class="`${prefixClass}-edit__main`"
      >
        <div :class="`${prefixClass}-edit__main-container`">
          <p v-if="emptyPlan" class="fz-14">
            Отсутствует подходящий план, нажмите на кнопку “Создать план
            согласования” ниже и заполните необходимые поля
          </p>
          <div
            v-else
            v-for="numPlan in metaData.panels[0].rows[0]
              .hrpac_coordination_stages.value"
            :key="numPlan"
            class="request-stage is-first"
          >
            <div class="request-stage__title flex-row">
              <span>
                <h5 class="fz-16 fw-500">
                  {{ formatHtml(numPlan.name.value) || 'Этап' }}
                </h5>
              </span>
              <span class="flex-row" style="justify-content: right">
                <p>Срок:</p>
                <p style="color: #0075db">
                  {{
                    numPlan.coordination_term_int.value
                      ? `${numPlan.coordination_term_int.value} раб. дн.`
                      : ''
                  }}
                </p>
                <p style="margin-left: 4px">Порядок согласования:</p>
                <p style="color: #0075db">
                  {{
                    numPlan.operator.options[numPlan.operator.value] ||
                    'неизвестно'
                  }}
                </p>
              </span>
            </div>
            <div
              v-for="operator in numPlan.hrpac_coordination_stage_result.value"
              :key="operator"
              class="request-stage__middle-block flex-row"
            >
              <p>Согласующий:</p>
              <p style="color: #0075db">
                {{
                  formatHtml(operator.user_name ? operator.user_name.value : '')
                }}
              </p>
              <Tooltip
                v-if="operator.user_id ? !operator.user_id.value : true"
                content="Отсутствует выбранный пользователь"
                effect="dark"
              >
                <Icon
                  iconName="CircleWarning"
                  iconColor="#EE1C1C"
                  class="title-icon"
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="showEditButton">
      <Divider dividerSize="1" hasLine class="bottom__divider" />
      <FormButtons
        v-for="item in metaData.bottom_menu"
        :key="item.id"
        :buttons_menu="[[item]]"
        topPanel
        view-type="detail"
        :breakOnSave="breakOnSave(item)"
        @get-intent="addFieldsToForm"
        @ClosePopup="closeDialog"
        class="bottom__buttons"
      ></FormButtons>
    </div>

    <div slot="footer">
      <div class="footer" v-if="metaData?.buttons_menu">
        <FormButtons
          v-for="item in metaData.buttons_menu"
          :key="item.id"
          :buttons_menu="[[item]]"
          topPanel
          view-type="detail"
          :breakOnSave="breakOnSave(item)"
          @get-intent="addFieldsToForm"
          @ClosePopup="closeDialog"
        ></FormButtons>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { store } from '@/store';
import { eventBus } from '@/bus';
import { getController } from '@/controllers/request';
import { Dialog } from 'element-ui';
import Divider from 'Elements/Divider/Divider';
import FormButtons from 'Elements/Form/FormButtons';
import Icon from 'Elements/Icon/Icon';
import Tooltip from 'Elements/Tooltip/Tooltip';
import {
  mixin,
  form,
  metadata,
  saveForm,
  errorMsg,
  rules,
  parseIntent
} from '@/utils/mixins';
import {
  DEFAULT_FORM_SIZE,
  EVENTBUS_EVENTS,
  INTENT_AREA
} from '@/utils/constants';

export default {
  mixins: [mixin, form, metadata, saveForm, rules, parseIntent, errorMsg],
  props: {
    metaData: {
      type: Object
    },
    is_visible: {
      type: Boolean
    }
  },
  data() {
    return {
      form: {},
      formKey: 0,
      updateKey: 0,
      formSize: DEFAULT_FORM_SIZE,
      options: {},
      blocked: {},
      module: null,
      prefixClass: 'request',
      rules: {},
      loading: false,
      requestUrl: '',
      files: [],
      emailSent: false,
      defaultParams: {},
      dialogLoading: false
    };
  },
  created() {
    eventBus.$on(EVENTBUS_EVENTS.FORM_ERROR, () => {
      this.showNotification({
        offset: 100,
        showClose: true,
        message: `Ошибка сохранения формы`,
        duration: 10000,
        type: 'error'
      });
    });
    eventBus.$on(EVENTBUS_EVENTS.CLOSE_POPUP, () => {
      this.closeDialog();
    });
    eventBus.$on(INTENT_AREA.NEW_HTML_PAGE, this.preview);
    eventBus.$on(EVENTBUS_EVENTS.DOWNLOAD_FILE, data => {
      if (data?.document_id) {
        this.downloadFileFromURL(
          process.env.VUE_APP_BASE_PATH +
            (process.env.VUE_APP_BASE_PATH.lastIndexOf('/') ==
            process.env.VUE_APP_BASE_PATH.length - 1
              ? ''
              : '/') +
            `index.php?entryPoint=download&id=${data.document_id}&type=Documents`
        );
      }
    });
  },

  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.FORM_ERROR);
    eventBus.$off(EVENTBUS_EVENTS.CLOSE_POPUP);
    eventBus.$off(INTENT_AREA.NEW_HTML_PAGE, this.preview);
    eventBus.$off(EVENTBUS_EVENTS.DOWNLOAD_FILE);
  },
  mounted() {
    this.form = {};
  },
  computed: {
    showEditButton() {
      if (this.metaData?.bottom_menu?.length) {
        const visibility = this.metaData?.bottom_menu[0]?.visibility;
        if (visibility && visibility === 'hidden') {
          return false;
        } else return true;
      } else return false;
    },
    popupWidth() {
      return store.state.dialog.size;
    },
    metadataTitle() {
      return this.metaData?.title?.main.length &&
        this.metaData?.title?.main[0]?.lbl?.value
        ? this.metaData.title.main[0].lbl.value
        : this.getIntentDialog &&
          this.getIntentDialog.lbl &&
          this.getIntentDialog.lbl.value
        ? this.getIntentDialog.lbl.value
        : 'План согласования';
    },
    getIntentDialog() {
      return store.state.dialog.intents;
    },

    getLoading() {
      return store.state.dialog.loading;
    },
    emptyPlan() {
      return !this.metaData.panels[0]?.rows[0]?.hrpac_coordination_stages
        ?.value[0].id.value;
    },
    editable() {
      return !!this.fields?.hrpac_coordination_request_id?.value;
    },
    fields() {
      return store.state.dialog.bean;
    },
    clickSaveform() {
      return store.state.common.clickSaveform;
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(value) {
        store.commit('common/setRequestState', value);
      }
    }
  },
  methods: {
    s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;

      return buf;
    },
    async preview(intent) {
      this.dialogLoading = true;

      try {
        let errorFields = this.getErrorValidFields(this.$refs.form);
        if (!errorFields.length) {
          const resp = await this.sendFormRequestFromIntent(
            intent,
            intent.intentArea == INTENT_AREA.NEW_HTML_PAGE ? {} : this.form
          );
          const file = new Blob([this.s2ab(atob(resp.data.fileData))], {
            type: resp.data.fileType
          });
          if (resp.data) {
            const windowParams = `location=no,toolbar=no,menubar=no,width=800,height=1000,left=100,top=100`;
            window
              .open(
                URL.createObjectURL(file),
                `Предпросмотр сформированного оффера:blank`,
                windowParams
              )
              .focus();
            URL.revokeObjectURL(file);
          } else if (resp.data?.errors && resp.data?.errors?.length) {
            this.showErrorMessage(resp.data.errors);
          }
        }
      } catch (err) {
        this.catchError(
          err,
          `Возникла ошибка предпросмотра резюме. Попробуйте еще раз.`
        );
      } finally {
        this.dialogLoading = false;
      }
    },
    breakOnSave(item) {
      return item?.intents && item.intents.length
        ? item.intents[0].intentArea != INTENT_AREA.SAVE
          ? false
          : this.metaData?.panels.length
          ? this.metaData?.panels[0]?.panel_id == 'lbl_communications' ||
            this.metaData?.panels[0]?.panel_id == 'lbl_candidate_save' ||
            this.metaData?.panels[1]?.panel_id == 'lbl_rejection_reasons_panel'
          : false
        : false;
    },

    async getDefaultParams(intent) {
      this.requestUrlgetDefaultParams = '/' + intent.request.url;
      for (const reqProp in intent.request.request_params) {
        let newObject = { [reqProp]: intent.request.request_params[reqProp] };
        this.defaultParams = { ...this.defaultParams, ...newObject };
      }
    },

    async addFieldsToForm(intents) {
      this.dialogLoading = true;
      if (!intents) {
        this.dialogLoading = false;
        return;
      }
      if (this.getIntentDialog.name === 'HRPAC_CANDIDATES_EXPORT_TO_XLSX') {
        try {
          const resp = await getController({
            url: intents[0].request.url,
            params: {
              ...intents[0].request.request_params,
              fields: this.form?.group_checkbox_button
            }
          });
          if (!resp || !resp.data) return;
          this.downloadFile(resp.data);
        } catch (error) {
          console.error(error);
        } finally {
          this.closeDialog();
        }
      } else if (this.getIntentDialog.intentArea === INTENT_AREA.CLOSE_POPUP) {
        this.closeDialog();
      } else {
        store.commit('event/setIntents', intents);
        await this.parse();
      }
      this.dialogLoading = false;
    },

    closeDialog() {
      store.commit('dialog/setRemoveDialogData');
      this.$emit('cancel-callback');
    }
  },
  components: {
    'el-dialog': Dialog,
    FormButtons,
    Divider,
    Icon,
    Tooltip
  }
};
</script>
<style lang="scss" scoped>
#front .dialog {
  & ::v-deep .el-dialog {
    padding: 0;

    &__header {
      padding: 20px 24px !important;
      border-bottom: 1px solid $black-20;
    }

    &__footer {
      width: 100%;
      padding: 20px 24px !important;
      margin-top: 0;
      border-top: 1px solid $black-20;

      .footer {
        width: 230px;
      }
    }
  }
}

.el-dialog {
  text-align: left;
}

.bottom {
  &__divider {
    margin-bottom: 24px;
  }

  &__buttons {
    justify-content: flex-end;
    display: flex;
  }
}

.request-edit {
  &__main {
    border-radius: 6px;

    color: $black-200;
    position: relative;
    overflow-y: auto;
    display: block;

    p {
      margin-right: 4px;
    }

    &::-webkit-scrollbar {
      width: 0px !important;
    }

    &-container {
      &__title {
        display: flex;
        flex-direction: row;
        margin: 0 0 8px 0;
        align-items: center;
      }

      .request-stage {
        box-sizing: border-box;
        border: 1px solid #cdd4da;
        border-radius: 4px;
        padding: 24px;
        margin-bottom: 16px;

        &__title {
          justify-content: space-between;

          span {
            // width: 100%;

            h5 {
              margin: 0;
              padding: 0;
              width: 100%;
              color: $black-200;
              word-break: normal;
            }
          }
        }

        &__middle-block {
          margin-top: 8px;
          align-items: center;
        }

        &:last-child {
          margin-bottom: 24px;
        }
      }

      // .is-first {
      //   margin-top: 20px;
      // }
    }
    &-footer {
      padding: 24px;
      text-align: right;
    }
  }
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.dialog__content {
  // max-height: 100vh;
  max-height: 100%;
  min-height: 100px;

  .open {
    display: block;
  }

  .hide {
    display: none;
  }
}
</style>

<style lang="scss">
.field {
  width: 50% !important;
}

.flex-row {
  display: flex;
  width: 100%;
}
</style>
